import * as Sentry from '@sentry/angular';

export const feedback = Sentry.feedbackIntegration({
	showBranding: false,
	autoInject: false, // Disable the default widget
	formTitle: 'Crowd Favorite Support',
	submitButtonLabel: 'Submit',
	messageLabel: 'Message',
	messagePlaceholder: 'Please provide any additional information that may help us assist you.',
	colorScheme: 'light',
	themeLight: {
		background: '#fff',
		foreground: '#000000',
		accentForeground: '#fff',
		accentBackground: '#e72412',
	}
});
